import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { TransformCta } from './CtaButton';
export function Guarantee() {
  return <section className="w-full bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-129" data-mp="1o33tsfx1zqh8">
      <div className="mx-auto max-w-2xl text-center" data-id="element-130" data-mp="223ofbjucs0ef">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold-500" data-id="element-131" data-mp="22128jmfadox9">
          <ShieldCheckIcon className="h-8 w-8 text-navy-950" aria-hidden="true" data-id="element-132" data-mp="1x2igr5e0hiwz" />
        </span>

        <h2 className="mt-5 font-display text-[24px] font-black leading-tight text-white sm:text-3xl" data-id="element-133" data-mp="19ceeb1ck7p7k">
          Tienes 7 días para comprobar que esta Ruta realmente transforma tu práctica clínica
        </h2>

        <p className="mt-4 text-[14px] leading-relaxed text-white/70 sm:text-lg" data-id="element-134" data-mp="1edtzcteqlvpy">
          Queremos que tomes esta decisión con total tranquilidad. Por eso asumimos todo el riesgo.
        </p>
        <p className="mt-3 text-[14px] leading-relaxed text-white/70 sm:text-lg" data-id="element-135" data-mp="lp6cwui950at">
          Si durante los próximos 7 días sientes que la Ruta no simplifica tus consultas ni mejora tu
          seguridad al tomar decisiones clínicas, solo escríbenos y te devolveremos el 100% de tu
          dinero.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-136" data-mp="ypl2pknk798a">
          {['Sin preguntas', 'Sin procesos complicados', 'Sin condiciones ocultas'].map(t => <span key={t} className="rounded-full border border-white/15 bg-white/5 px-3.5 py-1.5 text-[12px] font-semibold text-white/75 sm:text-sm" data-id="element-137" data-mp="12t0ti0cy6fd2">
              {t}
            </span>)}
        </div>

        <TransformCta tone="dark" headline="Pruébala sin riesgo durante 7 días." data-id="element-138" data-mp="f0alu3c2ui8l" />
      </div>
    </section>;
}